import { render, staticRenderFns } from "./TopStatistics.vue?vue&type=template&id=5bebe01b&scoped=true&"
import script from "./TopStatistics.vue?vue&type=script&lang=js&"
export * from "./TopStatistics.vue?vue&type=script&lang=js&"
import style0 from "./TopStatistics.vue?vue&type=style&index=0&id=5bebe01b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bebe01b",
  null
  
)

export default component.exports